export const paymentTypes = [
    { value: 0, label: "نقدي" },
    { value: 1, label: "اجل" }
]


export const clientsTypes = [
    "زبون",
    "مورد",
]


export const priceFields = [
    { value: "1", label: "مفرد" },
    { value: "2", label: "شبه جملة" },
    { value: "3", label: "جملة" },
    { value: "4", label: "اخرى1" },
    { value: "5", label: "اخرى2" },
]


export const damageType = {
    paint: { title: "صبغ", color: "#870040" },
    replace: { title: "تبديل", color: "#EFE0BA" },
    Scratche: { title: "خدوش", color: "#F2BACD" },
    plumbing: { title: "سمكرة بارد", color: "#BAF2D8" },
}

export const carTypes = [
    { value: "1", label: "صالون" },
    { value: "2", label: "تك باب" },
    { value: "3", label: "بيك اب" },
    { value: "4", label: "suv" },
    { value: "5", label: "suv+" },
    { value: "6", label: "هاج باك" },
]

export const plateTypes = [
    { value: "خصوصي", label: "خصوصي" },
    { value: "أجرة", label: "أجرة" },
    { value: "حمل", label: "حمل" },
    { value: "فحص مؤقت", label: "فحص مؤقت" },
]

export const sides = {
    side1: "الجانب الايسر",
    side2: "المصد الخلفي",
    side3: "الجانب الايمن",
    side4: "المصد الامامي",
    side5: "الجزء العلوي",
    // side6: "سقف السيارة",
    // side7: "غطاء الصندوق",
}